import { useQuery } from "@tanstack/react-query";
import { EligibilityControllerApi } from "../../services";
import { getConfigObject } from "../../utils/utils";

interface UseGetLatestEligibilityByInsuranceProps {
  patientId?: string;
  insuranceId?: string;
  xTENANTID?: string;
  enabled?: boolean;
}

/**
 * Fetches the latest eligibility record for a specific insurance of a patient.
 * Backend: GET /api/master/eligibility/all/{patientUuid}/{insuranceId}
 */
export function useGetLatestEligibilityByInsurance({
  patientId,
  insuranceId,
  xTENANTID,
  enabled = true,
}: UseGetLatestEligibilityByInsuranceProps) {
  return useQuery({
    queryKey: [
      "get-latest-eligibility-by-insurance",
      patientId,
      insuranceId,
      xTENANTID,
    ],
    enabled: enabled && !!patientId && !!insuranceId && !!xTENANTID,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new EligibilityControllerApi(getConfigObject())
        .getLatestEligibilityByInsurance(patientId!, insuranceId!, xTENANTID)
        .then((res) => res?.data),
  });
}
